<template>
  <VToolbar
    app
    fixed
    flat
    :color="'rgb(77,77,77, 0.8)'"
    :inverted-scroll="isHomeRoute"
    style="background-color: rgba(77, 77, 77, 0.8)"
    height="74px"
  >
    <VToolbarItems
      style="width: 100%; max-width: 1920px; margin: auto;"
      class="items"
    >
      <VLayout justify-space-between>
        <VFlex
          d-flex
          align-center
          justify-start
          style="width: 20%"
        >
          <router-link
            :to="{ name: 'Home' }"
            style="height: 80%; max-width: 150px;"
          >
            <img
              src="@/assets/logo.svg"
              style="height: 100%;"
              @click="scrollTop"
            >
          </router-link>
        </VFlex>

        <VFlex
          d-flex
          align-center
          justify-center
          style="max-width: 360px"
        >
          <router-link :to="'/#instax-az-eskuvon'">
            Instax az esküvőn?
          </router-link>

          <router-link :to="'/#csomagok'">
            Csomagok
          </router-link>

          <router-link :to="'/#gyik'">
            GYIK
          </router-link>
        </VFlex>

        <VFlex
          d-inline-flex
          style="width: 20%"
          align-center
          justify-end
        >
          <router-link
            :to="'/#kapcsolat'"
            style="max-width: 100px; margin-right: 15px;"
          >
            Kapcsolat
          </router-link>
        </VFlex>
      </VLayout>
    </VToolbarItems>

    <VLayout
      style="width: calc(100vw - 60px); height: 60px; position: relative;"
      align-center
      justify-center
      class="sideIcon"
    >
      <router-link
        :to="{ name: 'Home' }"
        class="mobileLogo"
      >
        <img
          src="@/assets/logo.svg"
          style="height: 100%;"
          @click="scrollTop"
        >
      </router-link>

      <VSpacer />

      <VToolbarSideIcon
        flat
        color="primary"
        style="max-width: 36px;"
        @click="showSheet = true"
      />
    </VLayout>

    <VBottomSheet
      v-model="showSheet"
      lazy
    >
      <VList>
        <VListTile @click="showSheet = false">
          <VListTileTitle class="title text-xs-center">
            <VIcon color="primary">
              close
            </VIcon>
          </VListTileTitle>
        </VListTile>

        <VListTile :to="'/#instax-az-eskuvon'">
          <VListTileTitle class="title text-xs-center">
            Instax az esküvőn?
          </VListTileTitle>
        </VListTile>

        <VListTile :to="'/#csomagok'">
          <VListTileTitle class="title text-xs-center">
            Csomagok
          </VListTileTitle>
        </VListTile>

        <VListTile :to="'/#gyik'">
          <VListTileTitle class="title text-xs-center">
            GYIK
          </VListTileTitle>
        </VListTile>

        <VListTile :to="'/#kapcsolat'">
          <VListTileTitle class="title text-xs-center">
            Kapcsolat
          </VListTileTitle>
        </VListTile>
      </VList>
    </VBottomSheet>
  </VToolbar>
</template>

<script>
export default {
  name: 'ThePageHeader',
  data() {
    return {
      showSheet: false,
    };
  },
  computed: {
    isHomeRoute() {
      return !this.$route.name || this.$route.name === 'Home';
    },
  },
  watch: {
    '$route.hash': {
      handler() {
        this.showSheet = false;
      },
    },
  },
  methods: {
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style scoped>
a {
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  text-decoration: none;
  text-align: center;
}

a:hover {
  color: #d1ae68;
}

@media (max-width: 600px) {
  .items {
    display: none;
  }
}

@media (min-width: 601px) {
  .sideIcon {
    display: none !important;
  }
}

.mobileLogo {
  height: 80%;
  max-width: 150px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
